import { tableFilterApi } from 'modules/tableFilter';
import { VENDOR_OPPORTUNITIES_REVENUE } from './vendorOpportunitiesRevenue';

export const financeListApi = {
  ...tableFilterApi,
  vendorOpportunitiesRevenue: VENDOR_OPPORTUNITIES_REVENUE,
};

export * from './useFinancePresets';
